import PropTypes from 'prop-types'
import {useEffect} from 'react'
import {List, Map} from 'immutable'

import ResponseResults from './ResponseResults'
import ItemResults from './ItemResults'
import ContactResults from './ContactResults'
import EmptyResults from './EmptyResults'

import {handleModalWrapperPosition} from '../../../../../lib/scrollTools'

import './searchResultsContainer.scss'

const SearchResultsContainer = props => {
  const {
    contactResults,
    itemResults,
    firmName,
    resetSearch,
    responseResults,
    textValue,
    userInitial,
    vaultExtension,
    vaultExtensionResults,
    ...otherProps
  } = props

  const wrapperPosition = handleModalWrapperPosition()

  const lockScroll = () => {
    wrapperPosition.lockWrapper()
    wrapperPosition.lockPage()
  }

  const unlockScroll = () => {
    wrapperPosition.unlockPage()
    wrapperPosition.unlockWrapper()
  }

  useEffect(() => {
    textValue ? lockScroll() : unlockScroll()
    return () => unlockScroll()
  }, [textValue])

  if (textValue) {
    return (
      <div className='search-results-container'>
        {responseResults.isEmpty() &&
          itemResults.isEmpty() &&
          contactResults.isEmpty() &&
          (!vaultExtensionResults || vaultExtensionResults.isEmpty()) && <EmptyResults textValue={textValue} />}
        <ResponseResults
          firmName={firmName}
          logEvent={props.logEvent}
          resetSearch={resetSearch}
          responseResults={responseResults}
          textValue={textValue}
          userInitial={userInitial}
          vaultExtension={vaultExtension}
          vaultExtensionResults={vaultExtensionResults}
          {...otherProps}
        />
        <ContactResults
          contactResults={contactResults}
          logEvent={props.logEvent}
        />
        <ItemResults
          categories={props.categories}
          itemResults={itemResults}
          kits={props.kits}
          logEvent={props.logEvent}
        />
      </div>
    )
  } else {
    return null
  }
}

SearchResultsContainer.propTypes = {
  categories: PropTypes.instanceOf(List),
  contactResults: PropTypes.instanceOf(List),
  firmName: PropTypes.string,
  itemResults: PropTypes.instanceOf(List),
  kits: PropTypes.instanceOf(Map),
  logEvent: PropTypes.func,
  resetSearch: PropTypes.func,
  responseResults: PropTypes.instanceOf(List),
  userInitial: PropTypes.string,
  vaultExtensionResults: PropTypes.instanceOf(List),
  vaultExtension: PropTypes.instanceOf(Map),
  textValue: PropTypes.string,
}

export default SearchResultsContainer
